import { useEffect, useState } from "react";
import pjImage from "../../../Assets/areas/PJ.webp";
import dmImage from "../../../Assets/areas/dubai-marina.webp";
import biImage from "../../../Assets/areas/BW.webp";
import jbrImage from "../../../Assets/areas/JBR.webp";
import dtImage from "../../../Assets/areas/DT.webp";
import emaarBech from "../../../Assets/areas/EmaarBeachfront.webp";
import Distric from "../../../Assets/areas/DistrictOne.webp";
import jvcc from "../../../Assets/areas/jvcc.webp";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

import pj_icon from "../../../Assets/PJ.png";
import bi_icon from "../../../Assets/BI.png";
import jbr_icon from "../../../Assets/JBR ICON.png";
import dt_icon from "../../../Assets/DT.png";
import { Link } from "react-router-dom";
const areas = [
  {
    name: "Palm Jumeirah",
    image: pjImage,
    icon: pj_icon,
    url: "/short-term-rentals/palm-jumeirah",
  },
  {
    name: "Dubai Marina",
    image: dmImage,
    icon: bi_icon,
    url: "/short-term-rentals/dubai-marina",
  },
  {
    name: "Bluewaters Island",
    image: biImage,
    icon: bi_icon,
    url: "/short-term-rentals/bluewaters-island",
  },
  {
    name: "JBR",
    image: jbrImage,
    icon: jbr_icon,
    url: "/short-term-rentals/jbr",
  },
  {
    name: "Downtown",
    image: dtImage,
    icon: dt_icon,
    url: "/short-term-rentals/downtown",
  },
  {
    name: "Emaar Beachfront",
    image: emaarBech,
    icon: dt_icon,
    url: "/short-term-rentals/emaar-beachfront",
  },
  {
    name: "District One",
    image: Distric,
    icon: dt_icon,
    url: "/short-term-rentals/district-one",
  },
  {
    name: "JVC",
    image: jvcc,
    icon: dt_icon,
    url: "/short-term-rentals/jumeirah-village-circle",
  },
];

export default function Areas() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="flex justify-center items-center py-20 bg-gray-100 font-inter">
      <div className="container text-center">
        <div className="mb-2">
          <p className="text-xl text-gray-500 mb-3">Discover Best</p>
          <h2 className="md:text-4xl text-xl font-bold text-[#4d4b47]">
            Areas in Dubai
          </h2>
        </div>
        <Swiper
          slidesPerView={3}
          spaceBetween={20}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            1280: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
          }}
          modules={[Pagination, Autoplay]}
          className="lg:w-auto md:w-auto w-full lg:px-0 md:px-0 customAreasSwiper"
        >
          {areas.map((area, index) => (
            <SwiperSlide key={index}>
              <Link to={area.url} key={index}>
                <div className="bg-white rounded-3xl overflow-hidden shadow-xl transform transition duration-300 hover:scale-105">
                  <div className="relative w-full h-64">
                    <img
                      src={area.image}
                      alt={area.name}
                      className="w-full h-full object-cover rounded-t-3xl"
                    />
                  </div>
                  <div className="px-4 py-6 flex items-center justify-start gap-3">
                    <img src={area?.icon} alt="" className="w-10" />
                    <span className="text-[16px] font-semibold text-[#4d4b47]">
                      {area.name}
                    </span>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
